<template>
  <div>
    <b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <b-card>
        <div class="d-flex justify-content-between align-items-center mb-2">
          <h4>{{ $t('active-sessions') }}</h4>
          <b-button
            :disabled="onDeleteAllLoading"
            variant="outline-danger"
            text-variant="danger"
            text
            @click="onDeleteAll"
          >
            <span v-if="!onDeleteAllLoading"> {{ $t('remove-all') }}</span>
            <b-spinner
              v-else
              small
              size="10"
              variant="danger"
              type="grow"
            />
          </b-button>
        </div>
        <b-table
          :items="activeSessions"
          :fields="tableFields"
          responsive
          striped
          hover
        >
          <template #cell(created_at)="data">
            {{ moment(data.item.created_at) }}
          </template>
          <template #cell(ip_info)="data">
            <span v-if="data.item.ip_info">
              {{ data.item.ip_info.country }} ({{ data.item.ip_info.city }})
            </span>
          </template>
          <template #cell(agent)="data">
            <div v-if="data.item.agent">
              <div>{{ $t('browser') }}: {{ data.item.agent.browser.name }}</div>
              <div>{{ $t('OS') }}: {{ data.item.agent.os.name }} ({{ data.item.agent.os.version }})</div>
            </div>
          </template>
          <template #cell(actions)="data">
            <b-button
              variant="outline-warning"
              size="sm"
              :disabled="onDeleteLoading"
              @click="onDelete(data.item)"
            >
              <span v-if="!onDeleteLoading">{{ $t('remove') }}</span>
              <b-spinner
                v-else
                small
                variant="warning"
                type="grow"
              />
            </b-button>
          </template>
        </b-table>
      </b-card>
    </b-overlay>
  </div>
</template>
<script>
import activeSessions from '@/views/logics/profile/activeSessions'
import moment from 'moment'

export default {
  mixins: [activeSessions],
  data() {
    return {
      moment,
      tableFields: [
        { key: 'ip_address', label: this.$t('IP-address') },
        { key: 'created_at', label: this.$t('date') },
        { key: 'ip_info', label: this.$t('country') },
        { key: 'agent', label: `${this.$t('browser')} / ${this.$t('OS')}` },
        { key: 'actions', label: this.$t('actions') },
      ],
    }
  },
}
</script>
